/**
 * @fileoverview Own the browser's Word-only upload policy shared by file selection and transfer controls. Accepted filename extensions coordinate those surfaces and their feedback; backend validation remains authoritative for stored bytes. `WordDocumentUploadField.js` consumes this policy, while media preview support is owned separately by `DocumentMedia.js`.
 */

export const WORD_DOCUMENT_EXTENSIONS = ['doc', 'docx', 'docm', 'dot', 'dotx', 'dotm'];
export const WORD_DOCUMENT_ACCEPT = WORD_DOCUMENT_EXTENSIONS.map(extension => `.${extension}`).join(',');
export const WORD_DOCUMENT_ONLY_MESSAGE = 'Only Word documents (.doc, .docx, .docm, .dot, .dotx, .dotm) belong in Documents. Store other files in Google Drive.';



export function isWordDocumentFilename(filename) {
  const basename = String(filename || '').split(/[\\/]/).pop();
  const suffixIndex = basename.lastIndexOf('.');
  return suffixIndex > 0 && WORD_DOCUMENT_EXTENSIONS.includes(basename.slice(suffixIndex + 1).toLowerCase());
}
